var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InviteTeammatesForm',{scopedSlots:_vm._u([{key:"progress-bar",fn:function(){return [_c('CompleteSignupProgressAtlassian',{attrs:{"currentStep":2}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }